var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.stylizationLogo,attrs:{"id":"logo","src":require('@/assets/images/logo/Logo Pernambucanas.svg'),"alt":"Logo\n    Pernambucanas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }